module.exports = __webpack_public_path__ + "257950dbd1b3d5b08e5f0472d6814c8c.glb";